import { MutationTree } from 'vuex'

import { QlogState } from '@/types/store'
import { IQlog } from '@/types/qlog'

export const mutations: MutationTree<QlogState> = {
  setIsLogsLoading(state, isLogsLoading: boolean) {
    state.isLogsLoading = isLogsLoading
  },
  logsLoaded(state, logs: IQlog[]) {
    state.logs = logs
  },
}
